import React from 'react'
import { TextValidator } from '@/housefolios-components/shared/muiFormValidator'
import { VALIDATION_RULES } from '@/constants/validation'

const NameInput = ({ value, setValue, label, placeholder  }) => {
  return (
    <TextValidator
      fullWidth={true}
      variant="outlined"
      placeholder={placeholder}
      label={label}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      validators={VALIDATION_RULES.name.validators}
      errorMessages={VALIDATION_RULES.name.errorMessages}
    />
  )
}

export default NameInput
